import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../../Components/Header/Header";
import LeftMenu from '../../../../../Components/LeftMenu/LeftMenu';

import firstImage from '../../../../../assets/images/warehouse.png';
import secondImage from '../../../../../assets/images/information.png';
import Docmnt from '../../../../../assets/images/google-docs.png';
import Trash from '../../../../../assets/images/trash.png';
import MailGreen from '../../../../../assets/images/mail_green.png';
import MailRed from '../../../../../assets/images/mail_red.png';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { Tab, Tabs, Modal, Row, Col, Button, Form } from 'react-bootstrap';
import { Step, StepLabel, Stepper } from '@mui/material';
import Select from 'react-select'
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import { GETAGENT, GETDESTINATION, GETOWNERCODE, SAVEHANDLER, SAVERECOVERY, STATIONHANDLER, STATIONLIST, ULDADDRESSSAVE } from '../../../../../Utils/conts.js';

const CreateCargo = () => {

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [originHandler, setOriginHandler] = useState([]);
    const [selectedOriginId, setSelectedOriginId] = useState(null);
    const [selectedOriginHandler, setSelectedOriginHandler] = useState(null);
    const [getDestination, setGetDestination] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [destinationHandler, setDestinationHandler] = useState([]);
    const [selectedDestinationId, setSelectedDestinationId] = useState(null);
    const [selectedDestinationHandler, setSelectedDestinationHandler] = useState(null);
    const [formData, setFormData] = useState({ pieces_weight_array: [], });
    const [addressFor, setAddressFor] = useState('');
    const [handlerList, setHandlerList] = useState([]);
    const [inputAddress, setInputAddress] = useState({
        handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
    });
    const [address, setAddress] = useState([]);

    const [morePacking, setMorePacking] = useState([
        // { station: '', stationHandler: [], selectedDestinationHandler: null }
    ]);
    const [generatedNumber, setGeneratedNumber] = useState();

    // IMAGE UPLOAD START
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    // IMAGE UPLOAD END

    const [addressModalShow, setAddressModalShow] = useState(false);
    const addressModalClose = () => { setAddressModalShow(false); setInputAddress({ handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: '' }) }

    const fetchStationData = async () => {
        try {

            const res = await withRFSToken.post(STATIONLIST, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchShipmentNumber = async () => {
        try {
            const res = await withRFSToken.get('shipment-export/generate-shipment-number', {})
                .then(function (res) {
                    const innerData = res.data.shipment_number;
                    setGeneratedNumber(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;

        fetchShipmentNumber()
        // fetchAddressData();
        // fetchOwnerCode();
        // fetchStationData();
        isMounted.current = true;
        const storedData = JSON.parse(localStorage.getItem('EditCargo'));
        if (storedData) {
            // const transformData = {
            //     ...storedData,
            //     files: storedData.attachments
            // }
            setFormData(storedData);

            setMorePacking(storedData.pieces_weight_array)
        }
    }, []);

    // ALL FORM
    const packingType = [
        { label: 'Package', value: '7' },
        { label: 'Other', value: '6' },
        { label: 'Barrel', value: '5' },
        { label: 'Crate', value: '4' },
        { label: 'Carton box', value: '3' },
        { label: 'Pallet', value: '2' },
        { label: 'Envelope', value: '1' },
    ]
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData(prevFormData => {
            // if (name === 'recovery_aspects') {
            //     const updatedAspects = checked
            //         ? [...(prevFormData.recovery_aspects || []), value] // Add the value if checked
            //         : (prevFormData.recovery_aspects || []).filter(item => item !== value); // Remove the value if unchecked

            //     return {
            //         ...prevFormData,
            //         recovery_aspects: updatedAspects
            //     };
            // }
            const generateUniqueNumber = () => {
                let date = new Date();
                let yearPrefix = date.getFullYear().toString().slice(-2); // Last two digits of the current year
                let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure two digits for month
                let milliseconds = date.getMilliseconds().toString().padStart(5, '0'); // Ensure five digits for milliseconds
                return yearPrefix + month + milliseconds;
            };
            if (name === "label_present") {
                if (value === "No") {
                    const uniqueNumber = generateUniqueNumber();
                    const organisation = "AMS";
                    return { ...prevFormData, [name]: value, label: organisation + "-TI-" + uniqueNumber, shipment_number: organisation + "-EA-" + generatedNumber };
                } else {
                    const storedData = JSON.parse(localStorage.getItem('EditCargo'));
                    return { ...prevFormData, [name]: value, label: storedData.label, shipment_number: storedData.shipment_number };
                }
            }
            if (name === "dangerous_goods" && value === "No") {
                const { dg_labels, ...updatedFormData } = prevFormData; // Remove dg_labels
                return { ...updatedFormData, [name]: value };
            }
            if (name === "dg_labels" && value === "No") {
                const { un, proper_shipping, packing_group, dg_class, net_quantity, ...updatedFormData } = prevFormData; // Remove dg_labels
                return { ...updatedFormData, [name]: value };
            }
            if (name === "dg_labels" && value === "Yes") {
                // const { un, proper_shipping, packing_group, net_quantity, ...updatedFormData } = prevFormData; // Remove dg_labels
                return { ...prevFormData, [name]: value, un: '', proper_shipping: '', packing_group: '', net_quantity: '' };
            }

            return { ...prevFormData, [name]: value };
        });
    };
    const handleChange = (value) => {
        console.log(value);

        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a space after the first 4 digits
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 9); // Limit to 9 characters (8 digits + 1 space)
    };
    // ALL FORM

    // STATION SECTION
    const [selectedStation, setSelectedStation] = useState({});
    const handleAddStation = () => {
        const validPacking = Array.isArray(morePacking) ? morePacking : [];
        const lastId = morePacking?.length > 0 ? parseInt(morePacking[morePacking.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setMorePacking([
            ...validPacking,
            { id: newId, pieces: '', weight: '', length: '', width: '', height: '', types_of_packing: '', types_of_packing_other: '', types_of_packing_desc: '' }
        ]);
        // setFormData(prevFormData => ({
        //     ...prevFormData,
        //     pieces_weight_array: [
        //         ...prevFormData.pieces_weight_array,
        //         { pieces: '', weight: '', length: '', width: '', height: '', types_of_packing: '', types_of_packing_other: '', types_of_packing_desc: '' } // Default notify_status to "0"
        //     ]
        // }));
    };
    const handleDeleteStation = (index) => {
        // Remove from stations array
        setMorePacking(prevStations => prevStations.filter((_, idx) => idx !== index));

        // Remove from formData.all_stations
        // setFormData(prevFormData => {
        //     const updatedStations = prevFormData.all_stations.filter((_, idx) => idx !== index);
        //     return { ...prevFormData, all_stations: updatedStations };
        // });
    };

    const handlePackingChange = (uldInfoId, fieldName, value, index) => {

        setMorePacking(prevFormData => prevFormData.map(entry => {
            if (entry.id === uldInfoId) {
                return { ...entry, [fieldName]: value };
            }
            return entry;
        }));

        setFormData(prevFormData => {
            const updatedPacking = [...prevFormData.pieces_weight_array];
            if (!updatedPacking[index]) {
                updatedPacking[index] = {};
            }
            // Ensure the object at the specific index exists, and set station_name
            updatedPacking[index] = {
                ...updatedPacking[index],       // Keep other existing properties
                [fieldName]: value,   // Set station_name explicitly
            };

            return { ...prevFormData, pieces_weight_array: updatedPacking };
        });
    };

    // STATION SECTION


    const validateAddressData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.handler_org_id) {
            toast.error('Please select a Handler name');
            isValid = false;
        }
        // else if (!validateEmail(inputAddress.handler_email_id)) {
        //     toast.error('Please enter valid email address');
        //     isValid = false;
        // }
        else {
            return isValid;
        }
    };

    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateAddressData()) {
            e.preventDefault();

            let stationid;
            if (addressFor == 'origin' || addressFor == 'OH') {
                stationid = selectedOriginId;
            } else if (addressFor == 'destination' || addressFor == 'DH') {
                stationid = selectedDestinationId;
            } else {
                stationid = selectedStation.station_id
            }
            const transformedEmails = inputAddress.handler_email_id.filter(email => email.trim() !== '');
            const NewInputAddress = { ...inputAddress, handler_email_id: transformedEmails, station_id: stationid };
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(SAVEHANDLER, NewInputAddress)
                        .then(function (res) {
                            // const innerData = res;
                            if (res.data.response_code == 200) {
                                toast.success(res.data.response_msg);
                                const newAddress = res.data.response_data;
                                setAddress(newAddress);
                                // fetchStationData();
                                fetchStationData();
                                if (addressFor === 'origin' || addressFor === 'destination') {

                                }
                                if (addressFor == 'origin') {
                                    setOriginHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                    // setTimeout(() => {
                                    //     if (originHandler.length === 1) {
                                    //         setSelectedOriginHandler({ value: newAddress.id, label: newAddress.company_name })
                                    //     }
                                    // }, 500);
                                } else if (addressFor == 'destination') {
                                    setDestinationHandler(prevHandlerNames => [
                                        ...prevHandlerNames,
                                        newAddress
                                    ]);
                                } else if (addressFor == 'OH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedOriginHandler(transformData);
                                } else if (addressFor == 'DH') {
                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                    }
                                    setSelectedDestinationHandler(transformData);
                                } else if (addressFor == 'SH') {

                                    const transformData = {
                                        value: newAddress?.id,
                                        label: newAddress?.company_name,
                                        email: newAddress?.handler_email_id,
                                        address: newAddress?.address,
                                        number: newAddress?.handler_phone_no,
                                        id: newAddress?.handler_contact_id,
                                        hoid: newAddress?.handler_org_id,
                                        station_id: newAddress?.station_id
                                    }
                                    // console.log('transformData=1', transformData);
                                    // setSelectedStation(transformData);
                                    setMorePacking(prevStations =>
                                        prevStations.map(station =>
                                            station.station_id === selectedStation.station_id
                                                ? {
                                                    ...station,
                                                    selectedDestinationHandler: transformData, // Update stationHandler with newAddress data
                                                    stationHandler: station.stationHandler.map(handler =>
                                                        handler.handler_org_id === newAddress.handler_org_id
                                                            ? { ...handler, ...newAddress } // Replace the matched handler with newAddress
                                                            : handler // Keep the other handlers unchanged
                                                    ),
                                                }
                                                : station
                                        )
                                    );
                                } else {
                                    // const stnHandler = stations?.find(name => name.station === selectedStation.station);

                                    setMorePacking(prevStations =>
                                        prevStations.map(station =>
                                            station.station === selectedStation.station
                                                ? {
                                                    ...station,
                                                    stationHandler: [...station.stationHandler, newAddress] // Update stationHandler with newAddress data
                                                }
                                                : station
                                        )
                                    );
                                }
                                setInputAddress({
                                    handler_org_id: '', address: '', handler_email_id: [''], handler_phone_no: ''
                                });
                                // console.log(address);
                                addressModalClose();
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
            }
        }
    }
    // ADDRESS MODAL END

    // IMAGE UPLOAD START
    const [isTopDel, setIsTopDel] = useState(false);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, id, type) => {
        if (isTopDel) {
            setEditFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        } else {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                setFormData((prevFormData) => {
                    const newFormData = { ...prevFormData, base64Files: newBase64Files };
                    return newFormData;
                });

                return newBase64Files;
            });
        }

    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];
        const existingFiles = formData?.files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setFormData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, files: mergedFiles, base64Files: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const handleDeleteImage = (index, id, type) => {
        setIsTopDel(true);
        handleDeleteFile(index);
        // setShowConfirmation(true); need to work
    };
    // IMAGE UPLOAD END

    const [activeStep, setActiveStep] = useState(0);
    const [finishStep, setFinishStep] = useState(false);

    const steps = [
        { label: (<>Shipment Information</>), icon: <img src={firstImage} /> },
        { label: (<>Shipment Aspects</>), icon: <img src={firstImage} /> },
        { label: (<>Acceptance</>), icon: <img src={secondImage} /> },
        { label: (<>Upload Pictures</>), icon: <img src={secondImage} /> },
    ];

    const stepNext = () => {
        // if (activeStep === 0) {
        //     if (!formData.master_airway_bill_prefix) {
        //         toast.error("Please Add Master Airway Bill Prefix");
        //         return;
        //     }
        //     if (!formData.master_airway_bill_no) {
        //         toast.error("Please Add Master Airway Bill Number");
        //         return;
        //     }
        //     if (!formData.flight_prefix) {
        //         toast.error("Please Add Flight Prefix");
        //         return;
        //     }
        //     if (!formData.flight_no) {
        //         toast.error("Please Add Flight Number");
        //         return;
        //     }
        //     if (!formData.flight_date) {
        //         toast.error("Please Select Flight Date");
        //         return;
        //     }
        //     if (!formData.origin) {
        //         toast.error("Please Select Origin");
        //         return;
        //     }
        //     if (!formData.origin_handler_id) {
        //         toast.error("Please Select Origin Handler");
        //         return;
        //     }
        //     if (!formData.destination) {
        //         toast.error("Please Select Destination");
        //         return;
        //     }
        //     if (!formData.destination_handler_id) {
        //         toast.error("Please Select Destination Handler");
        //         return;
        //     }
        // } else if (activeStep === 1) {
        //     if (!formData.total_mawb_pieces) {
        //         toast.error("Please enter Total Mawb Pieces");
        //         return;
        //     }
        //     if (!formData.total_mawb_wght) {
        //         toast.error("Please enter Total Mawb Weight");
        //         return;
        //     }
        //     if (!formData.pieces_involved) {
        //         toast.error("Please enter Pieces Involved");
        //         return;
        //     }
        //     if (!formData.pieces_wght) {
        //         toast.error("Please enter Involved Weight");
        //         return;
        //     }
        //     if (!formData.recovery_aspects || !formData.recovery_aspects?.length > 0) {
        //         toast.error("Please Select Recovery Aspects");
        //         return;
        //     }
        // }

        // Move to the next step if all validations passed
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // if (boolNext == 1) {
        //     setActiveStep((prevActiveStep) => prevActiveStep + 1);
        // }
    };
    const stepBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleFinish = async () => {
        setIsLoading(true);
        // let transformedData;
        // if (localStorage.getItem('RecoveryEdit')) {

        // } else {
 
        console.log("line no==>731", formData)
        try {
            const res = await withRFSToken.post('shipment-export/edit-cargo', formData)
                .then(function (res) {
                    setIsLoading(false);
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        // setTimeout(() => {
                        window.location.href = '/ForwarderShipments/Export';
                        // }, 1000);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleStepClick = (stepIndex) => {
        setActiveStep(stepIndex);
        // if (completedData[stepIndex]) {
        //     setActiveStep(stepIndex);
        // }
    }

    // image select
    const [selectedKeys, setSelectedKeys] = useState([]);

    const handleImageSelect = (key, data) => {
        console.log("🚀 ~ handleImageSelect ~ data:", data)

        if (formData.files) {
            const extension = data?.name?.split('.').pop().toLowerCase();
            if (["jpeg", "jpg", "png", "webp"].includes(extension)) {
                setFormData((prevFormData) => {
                    const updatedFiles = prevFormData.files.map((file, index) => {
                        if (index === key) {
                            // Toggle the "primary" field for the selected file
                            return {
                                ...file,
                                primary: file.primary === 1 ? 0 : 1,
                            };
                        }
                        return file;
                    });

                    return {
                        ...prevFormData,
                        files: updatedFiles,
                    };
                });
                // setFiles((prevFiles) =>
                //     prevFiles.map((file, index) =>
                //         index === key
                //             ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                //             : file // Leave other files unchanged
                //     )
                // );
                setSelectedKeys((prevSelected) =>
                    prevSelected.includes(key)
                        ? prevSelected.filter((selectedKey) => selectedKey !== key) // Remove key if already selected
                        : [...prevSelected, key] // Add key if not selected
                );
            }
        }
        if (["jpeg", "jpg", "png", "webp"].includes(data?.file_type)) {

            setEditFiles((prevFiles) =>
                prevFiles.map((file) =>
                    file.id === data.id
                        ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
                        : file // Leave other files unchanged
                )
            );
        }

    };

    return (
        <>
            <div className="">
                {console.log('morePacking', morePacking)}
                {console.log('formData', formData)}
                {/* {console.log('stations', stations)} */}
                {/* {console.log('inputAddress', inputAddress)} */}
                {/* {console.log('handlerList', handlerList)} */}
                <Header page_type='fsm' logo_url='/ForwarderShipments/Export' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <Link to={JSON.parse(localStorage.getItem('ccbackUrl'))} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        <div className="mainTab serve_recovery position-relative">
                            {isLoading ? <><div className='mvt loader-container h-100'><span className='mvt loader' style={{ left: '48%', top: '48%' }}></span></div></> : ''}
                            <Row>
                                <Col sm='3'>
                                    <div className='missing_info h-100 px-4'>
                                        <Stepper activeStep={activeStep} orientation="vertical" className='recovery_step'>
                                            {steps.map(({ label }, index) => (
                                                <Step key={index} disabled={index !== activeStep} className="">
                                                    <StepLabel onClick={() => handleStepClick(index)}>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </div>
                                </Col>
                                <Col sm='9'>
                                    <div className='missing_info d-flex h-100'>
                                        <div className='charter_from w65'>
                                            {activeStep === 0 &&
                                                <>
                                                    <Form className='recover_middle'>
                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col sm="6" className='pe-0' >

                                                                <Form.Label>Expected Pieces <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='expected_total_pieces'
                                                                    maxLength='8'
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    value={formData.expected_total_pieces || ''}
                                                                    onChange={handleInputChange}

                                                                />
                                                            </Col>
                                                            <Col sm="6" className='pe-0' >
                                                                <Form.Label>Expected Weight <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='expected_total_weight'
                                                                    maxLength='8'
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    value={formData.expected_total_weight || ''}
                                                                    onChange={handleInputChange}

                                                                />
                                                            </Col>
                                                        </Form.Group>

                                                        <Form.Group className="mb-2 sl_status">
                                                            <Form.Label>Label Present <span>*</span></Form.Label>
                                                            <Form.Check
                                                                label="YES"
                                                                name="label_present"
                                                                type='radio'
                                                                id='label_presenty'
                                                                value="Yes"
                                                                checked={formData.label_present === 'Yes'}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Check
                                                                label="NO"
                                                                name="label_present"
                                                                type='radio'
                                                                id='label_presentn'
                                                                value="No"
                                                                checked={formData.label_present === 'No'}
                                                                onChange={handleInputChange}
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" >
                                                            <Col sm="12" className='pe-0'>
                                                                <Form.Label>Label <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="label"
                                                                    maxLength="8"
                                                                    value={formData.label || ""}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" >
                                                            <Col sm="12" className='pe-0'>
                                                                <Form.Label>Shipment Number <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='shipment_number'
                                                                    maxLength='13'
                                                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 13); }}
                                                                    value={formData.shipment_number || ''}
                                                                    onChange={handleInputChange}

                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" >
                                                            <Col sm="12" className='pe-0'>
                                                                <Form.Label>Destination <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="destination"
                                                                    value={formData.destination || ""}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" >
                                                            <Col sm="12" className='pe-0'>
                                                                <Form.Label>Shipper Name <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="shipper_name"
                                                                    value={formData.shipper_name || ""}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" >
                                                            <Col sm="12" className='pe-0'>
                                                                <Form.Label>Shipper City <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="city"
                                                                    maxLength="8"
                                                                    value={formData.city || ""}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                    </Form>
                                                </>
                                            }
                                            {activeStep === 1 &&
                                                <Form className='recover_middle'>
                                                    <Form.Group className="mb-2 sl_status">
                                                        <Form.Label>Address label available ? <span>*</span></Form.Label>
                                                        <Form.Check
                                                            label="YES"
                                                            name="address_lable"
                                                            type='radio'
                                                            // id='Flight'
                                                            value="Yes"
                                                            checked={formData.address_lable === 'Yes'}
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Check
                                                            label="NO"
                                                            name="address_lable"
                                                            type='radio'
                                                            // id='Flight'
                                                            value="No"
                                                            checked={formData.address_lable === 'No'}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2 sl_status">
                                                        <Form.Label>Dangerous goods ? <span>*</span></Form.Label>
                                                        <Form.Check
                                                            label="YES"
                                                            name="dangerous_goods"
                                                            type='radio'
                                                            // id='Flight'
                                                            value="Yes"
                                                            checked={formData.dangerous_goods === 'Yes'}
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Check
                                                            label="NO"
                                                            name="dangerous_goods"
                                                            type='radio'
                                                            // id='Flight'
                                                            value="No"
                                                            checked={formData.dangerous_goods === 'No'}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Form.Group>
                                                    {formData.dangerous_goods === 'Yes' &&
                                                        <Form.Group className="mb-2 sl_status">
                                                            <Form.Label>DG labels available? <span>*</span></Form.Label>
                                                            <Form.Check
                                                                label="YES"
                                                                name="dg_labels"
                                                                type='radio'
                                                                // id='Flight'
                                                                value="Yes"
                                                                checked={formData.dg_labels === 'Yes'}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Check
                                                                label="NO"
                                                                name="dg_labels"
                                                                type='radio'
                                                                // id='Flight'
                                                                value="No"
                                                                checked={formData.dg_labels === 'No'}
                                                                onChange={handleInputChange}
                                                            />
                                                        </Form.Group>
                                                    }
                                                    <Form.Group className="mb-2 sl_status">
                                                        <Form.Label>Bonded  <span>*</span></Form.Label>
                                                        <Form.Check
                                                            label="YES"
                                                            name="bonded"
                                                            type='radio'
                                                            // id='Flight'
                                                            value="Yes"
                                                            checked={formData.bonded === 'Yes'}
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Check
                                                            label="NO"
                                                            name="bonded"
                                                            type='radio'
                                                            id='Flight'
                                                            value="No"
                                                            checked={formData.bonded === 'No'}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2 sl_status">
                                                        <Form.Label>Security Status <span>*</span></Form.Label>
                                                        <Form.Check
                                                            label="Known"
                                                            name="security_status"
                                                            type='radio'
                                                            // id='Flight'
                                                            value="Yes"
                                                            checked={formData.security_status === 'Yes'}
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Check
                                                            label="Unknown"
                                                            name="security_status"
                                                            type='radio'
                                                            // id='Flight'
                                                            value="No"
                                                            checked={formData.security_status === 'No'}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-2 sl_status">
                                                        <Form.Label>Any Damage Noticed ? <span>*</span></Form.Label>
                                                        <Form.Check
                                                            label="YES"
                                                            name="is_damaged"
                                                            type='radio'
                                                            id='Flight'
                                                            value="Yes"
                                                            checked={formData.is_damaged === 'Yes'}
                                                            onChange={handleInputChange}
                                                        />
                                                        <Form.Check
                                                            label="NO"
                                                            name="is_damaged"
                                                            type='radio'
                                                            id='Flight'
                                                            value="No"
                                                            checked={formData.is_damaged === 'No'}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Form.Group>
                                                    {formData.dg_labels === 'Yes' &&
                                                        <>
                                                            <Form.Group as={Row} className="mb-2" >
                                                                <Col sm="12" className='pe-0'>
                                                                    <Form.Label>UN </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="un"
                                                                        maxLength="8"
                                                                        value={formData.un || ""}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} className="mb-2" >
                                                                <Col sm="6" className='pe-0'>
                                                                    <Form.Label>Proper Shipping Name </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="proper_shipping"
                                                                        maxLength="8"
                                                                        value={formData.proper_shipping || ""}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Col>
                                                                <Col sm="6" className='pe-0'>
                                                                    <Form.Label>Class </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="dg_class"
                                                                        maxLength="8"
                                                                        value={formData.dg_class || ""}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                            <Form.Group as={Row} className="mb-2" >
                                                                <Col sm="6" className='pe-0'>
                                                                    <Form.Label>Packing Group </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="packing_group"
                                                                        maxLength="8"
                                                                        value={formData.packing_group || ""}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Col>
                                                                <Col sm="6" className='pe-0'>
                                                                    <Form.Label>Net Quantity </Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="net_quantity"
                                                                        maxLength="8"
                                                                        value={formData.net_quantity || ""}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                </Col>
                                                            </Form.Group>
                                                        </>
                                                    }
                                                    <Form.Group >
                                                        <Form.Label>Remark</Form.Label>
                                                        <Form.Control as="textarea" name='remarks' onChange={handleInputChange} rows={5} value={formData.remarks} />
                                                    </Form.Group>

                                                </Form>
                                            }
                                            {activeStep === 2 &&
                                                <>
                                                    <Form className='recover_middle'>
                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col sm="6" className='pe-0' >

                                                                <Form.Label>Expected Pieces <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='expected_total_pieces'
                                                                    maxLength='8'
                                                                    disabled
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    value={formData.expected_total_pieces || ''}
                                                                    onChange={handleInputChange}

                                                                />
                                                            </Col>
                                                            <Col sm="6" className='pe-0' >
                                                                <Form.Label>Expected Weight <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='expected_total_weight'
                                                                    maxLength='8'
                                                                    disabled
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    value={formData.expected_total_weight || ''}
                                                                    onChange={handleInputChange}

                                                                />
                                                            </Col>
                                                        </Form.Group>


                                                        <Form.Group as={Row} className="mb-2">
                                                            <Col sm="6" className='pe-0' >

                                                                <Form.Label>Received Pieces <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='received_pieces'
                                                                    maxLength='8'
                                                                    disabled
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    value={formData.received_pieces || ''}
                                                                    onChange={handleInputChange}

                                                                />
                                                            </Col>
                                                            <Col sm="6" className='pe-0' >
                                                                <Form.Label>Received Weight <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name='received_weight'
                                                                    maxLength='8'
                                                                    disabled
                                                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                    value={formData.received_weight || ''}
                                                                    onChange={handleInputChange}

                                                                />
                                                            </Col>
                                                        </Form.Group>

                                                        {morePacking?.map((station, index) => (
                                                            <div key={index}>
                                                                <Form.Group as={Row} className="my-3 add_station position-relative">
                                                                    <Col sm="13" className='pe-0'>
                                                                        <Form.Label>Type of Packing  <span>*</span></Form.Label>
                                                                        <Select
                                                                            options={packingType}
                                                                            onChange={(selected) => handlePackingChange(station.id, 'types_of_packing', selected.value, index)}
                                                                            placeholder="Packing"
                                                                            className='autoslct'
                                                                            name='types_of_packing'
                                                                            value={packingType.find(option => option.value === station.types_of_packing) || ''}
                                                                        />
                                                                    </Col>
                                                                    <Form.Group as={Row} className="mb-2">
                                                                        <Col sm="2" className='pe-0' >
                                                                            <Form.Label>Pieces </Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name='pieces'
                                                                                maxLength='8'
                                                                                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                                value={station.pieces || ''}
                                                                                onChange={(e) => handlePackingChange(station.id, 'pieces', e.target.value, index)}

                                                                            />
                                                                        </Col>
                                                                        <Col sm="2" className='pe-0' >
                                                                            <Form.Label>Length </Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name='length'
                                                                                maxLength='8'
                                                                                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                                value={station.length || ''}
                                                                                onChange={(e) => handlePackingChange(station.id, 'length', e.target.value, index)}

                                                                            />
                                                                        </Col>
                                                                        <Col sm="2" className='pe-0' >
                                                                            <Form.Label>Width </Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name='width'
                                                                                maxLength='8'
                                                                                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                                value={station.width || ''}
                                                                                onChange={(e) => handlePackingChange(station.id, 'width', e.target.value, index)}

                                                                            />
                                                                        </Col>
                                                                        <Col sm="2" className='pe-0' >
                                                                            <Form.Label>Height </Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name='height'
                                                                                maxLength='8'
                                                                                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                                value={station.height || ''}
                                                                                onChange={(e) => handlePackingChange(station.id, 'height', e.target.value, index)}

                                                                            />
                                                                        </Col>
                                                                        <Col sm="2" className='pe-0' >
                                                                            <Form.Label>Weight </Form.Label>
                                                                            <Form.Control
                                                                                type="text"
                                                                                name='weight'
                                                                                maxLength='8'
                                                                                onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                                value={station.weight || ''}
                                                                                onChange={(e) => handlePackingChange(station.id, 'weight', e.target.value, index)}
                                                                            />
                                                                        </Col>
                                                                        {station.types_of_packing === '6' &&
                                                                            <Col sm="2" className='pe-0' >
                                                                                <Form.Label>Other Type<span>*</span></Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    name='types_of_packing_other'
                                                                                    // maxLength='8'
                                                                                    // onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 8); }}
                                                                                    value={station.types_of_packing_other || ''}
                                                                                    onChange={(e) => handlePackingChange(station.id, 'types_of_packing_other', e.target.value, index)}
                                                                                />
                                                                            </Col>
                                                                        }

                                                                    </Form.Group>


                                                                    <Link to="#" onClick={() => handleDeleteStation(index)} className='recovery_trash'>
                                                                        <img src={Trash} />
                                                                    </Link>
                                                                </Form.Group>
                                                            </div>
                                                        ))}

                                                        <Button variant="outline-primary" className='more_btn mt-3' onClick={handleAddStation}>
                                                            Add More Packing
                                                        </Button>



                                                        <Form.Group as={Row} className="mb-2" >
                                                            <Col sm="14" className='pe-0'>
                                                                <Form.Label>Storage Location <span>*</span></Form.Label>
                                                                <Form.Control
                                                                    type="text"
                                                                    name="location"
                                                                    maxLength="8"
                                                                    value={formData.location || ""}
                                                                    onChange={(e) => {
                                                                        const inputValue = e.target.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 8); // Allows letters & numbers, limits to 8 chars
                                                                        handleInputChange({ target: { name: "location", value: inputValue } });
                                                                    }}
                                                                />
                                                            </Col>


                                                        </Form.Group>

                                                    </Form>

                                                </>
                                            }
                                            {activeStep === 3 &&
                                                <>
                                                    <Form.Group >
                                                        <div className='recover_middle'>
                                                            <div>
                                                                <Form.Label>Upload Documents/Images </Form.Label>
                                                                <div
                                                                    className="dropfile "
                                                                    onDrop={handleDrop}
                                                                    onDragOver={handleDragOver}
                                                                >
                                                                    <h3>Drag and drop files here</h3>
                                                                    <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                                                    <span>Maximum file size 4 MB</span>
                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        style={{ display: 'none' }}
                                                                        onChange={handleFileChange}
                                                                        multiple
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className='d-flex upimg_recover'>
                                                                <span className='frprimary'>User can select image for primary image </span>
                                                                {editFiles &&
                                                                    <>
                                                                        {editFiles?.map((file, index) => {
                                                                            const fileName = file?.file_name;
                                                                            // console.log("🚀 ~ {files.map ~ file:", file)
                                                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                            const extension = fileName?.split(".").pop();
                                                                            return (
                                                                                <>
                                                                                    {file.original_file_path == 'service_recovery_edit_files' &&
                                                                                        <>
                                                                                            <div key={`ns_${index}`} className={`img-thumbnail ${file.primary === 1 ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                                                                {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                                ) ? (
                                                                                                    <>
                                                                                                        <img
                                                                                                            src={file.file_path}
                                                                                                            alt="Preview"
                                                                                                            style={{
                                                                                                                maxWidth: "30px",
                                                                                                                maxHeight: "30px",
                                                                                                                marginRight: "10px",
                                                                                                            }}

                                                                                                        />
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <>
                                                                                                        <span className="">
                                                                                                            <img src={Docmnt} className="fileimg" />
                                                                                                        </span>
                                                                                                    </>
                                                                                                )}
                                                                                                <span className="rafilename">
                                                                                                    {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                                </span>

                                                                                                <button
                                                                                                    className="dltbtn"
                                                                                                    type="button"
                                                                                                    onClick={() =>
                                                                                                        handleDeleteImage(index, file.id, file.attachment_type)
                                                                                                    }
                                                                                                >
                                                                                                    <FontAwesomeIcon icon={faCircleXmark} />
                                                                                                </button>
                                                                                                {/* )} */}
                                                                                            </div>
                                                                                        </>
                                                                                    }
                                                                                </>
                                                                            );
                                                                        })}
                                                                    </>
                                                                }
                                                                {files?.map((file, index) => {
                                                                    console.log("🚀 ~ {files?.map ~ file:", file)
                                                                    const fileName = file.name;
                                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                    const extension = fileName?.split(".").pop();
                                                                    return (
                                                                        <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                                                                            {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                                                            ) ? (
                                                                                <>
                                                                                    <img
                                                                                        src={URL.createObjectURL(file)}
                                                                                        alt="Preview"
                                                                                        style={{
                                                                                            maxWidth: "30px",
                                                                                            maxHeight: "30px",
                                                                                            marginRight: "5px",
                                                                                        }}

                                                                                    />
                                                                                    <span>
                                                                                        {/*file.file_name*/}
                                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`}
                                                                                    </span>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <span className="d-flex align-items-center">
                                                                                        <img src={Docmnt} style={{
                                                                                            maxWidth: "30px",
                                                                                            maxHeight: "30px",
                                                                                            marginRight: "5px",
                                                                                        }} />
                                                                                        <span>{file.name}</span>
                                                                                    </span>
                                                                                </>
                                                                            )}


                                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </>
                                            }
                                            <div className='ordernext'>
                                                <Button onClick={stepBack} variant="contained" disabled={activeStep === 0 || false}>
                                                    Back
                                                </Button>
                                                <Button className='trnext' variant="contained" onClick={activeStep === steps.length - 1 ? handleFinish : stepNext}>
                                                    {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                                                </Button>
                                            </div>
                                        </div>
                                        <div className='w35 recover_right'>
                                            <h4>Shipment Information</h4>
                                            <ul>
                                                <li>
                                                    <span>Expected Pieces :</span>
                                                    <span>{formData?.pieces}</span>
                                                </li>
                                                <li>
                                                    <span>Expected Weight :</span>
                                                    <span>{formData?.weight}</span>
                                                </li>
                                                <li>
                                                    <span>Label Present :</span>
                                                    <span>{formData?.label_present}</span>
                                                </li>
                                                <li>
                                                    <span>Label :</span>
                                                    <span>{formData?.label}</span>
                                                </li>
                                                <li>
                                                    <span>Shipment Number :</span>
                                                    <span>{formData?.shipment_no}</span>
                                                </li>
                                                <li>
                                                    <span>Destination :</span>
                                                    <span>{formData?.destination}</span>
                                                </li>
                                                <li>
                                                    <span>Shipper Name :</span>
                                                    <span>{selectedDestinationHandler?.label}</span>
                                                </li>
                                                <li>
                                                    <span>Shipper City :</span>
                                                    <span>{selectedDestinationHandler?.label}</span>
                                                </li>
                                                {formData?.all_stations?.map((stn, index) => {

                                                    let companyName = null;

                                                    for (const station of getDestination) {
                                                        const matchedAddress = station.address?.find(addr => addr.id === stn.handler_id);
                                                        if (matchedAddress) {
                                                            companyName = matchedAddress.company_name;
                                                            break;
                                                        }
                                                    }
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <li key={index}>
                                                                <span>Station :</span>
                                                                <span>{stn?.station_name}</span>
                                                            </li>
                                                            <li>
                                                                <span>Station Handler :</span>
                                                                <span>{companyName || ''}</span>
                                                            </li>
                                                        </React.Fragment>
                                                    )
                                                }
                                                )}
                                            </ul>
                                            <hr />
                                            <h4>Shipment Aspects</h4>
                                            <ul>
                                                <li>
                                                    <span>Address Label Available:</span>
                                                    <span>{formData?.address_lable}</span>
                                                </li>
                                                <li>
                                                    <span>Dangerous Goods :</span>
                                                    <span>{formData?.dangerous_goods}</span>
                                                </li>
                                                <li>
                                                    <span>Bonded :</span>
                                                    <span>{formData?.bonded}</span>
                                                </li>
                                                <li>
                                                    <span>Security Status :</span>
                                                    <span>{formData?.security_status}</span>
                                                </li>
                                                <li>
                                                    <span>Any Damage Noticed :</span>
                                                    <span>{formData?.is_damaged}</span>
                                                </li>
                                                <li>
                                                    <span>Remarks :</span>
                                                    <span className='reco_comment'>{formData?.remarks}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default CreateCargo;